import { createContext, useContext, useState } from 'react'
import { cn } from '../../lib/utils'

const TooltipContext = createContext(null)

export function TooltipProvider({ children }) {
    return <div className="relative inline-block">{children}</div>
}

export function Tooltip({ children }) {
    const [open, setOpen] = useState(false)
    return (
        <TooltipContext.Provider value={{ open, setOpen }}>
            <div 
                className="relative inline-block"
                onMouseEnter={() => setOpen(true)}
                onMouseLeave={() => setOpen(false)}
            >
                {children}
            </div>
        </TooltipContext.Provider>
    )
}

export function TooltipTrigger({ children, asChild, ...props }) {
    return <div {...props}>{children}</div>
}

export function TooltipContent({ children, className, side = 'top', ...props }) {
    const context = useContext(TooltipContext)
    const open = context ? context.open : false

    if (!open) return null

    return (
        <div
            className={cn(
                'absolute z-50 px-2 py-1 text-xs font-medium text-white bg-gray-900 rounded-md shadow-lg whitespace-nowrap pointer-events-none',
                'dark:bg-gray-800 dark:text-gray-100',
                side === 'top' ? 'bottom-full left-1/2 -translate-x-1/2 mb-2' : 'top-full left-1/2 -translate-x-1/2 mt-2',
                className
            )}
            {...props}
        >
            {children}
            {/* Arrow */}
            <div 
                className={cn(
                    "absolute left-1/2 -translate-x-1/2 w-2 h-2 bg-gray-900 dark:bg-gray-800 rotate-45",
                    side === 'top' ? "-bottom-1" : "-top-1"
                )}
            />
        </div>
    )
}